// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("./img/homesightlogo.svg", import.meta.url);
var ___HTML_LOADER_IMPORT_1___ = new URL("./img/signout.svg", import.meta.url);
// Module
var code = `<div class="main">
  <div class="head">
    <div class="nav-item-containers">
      <div class="logo">
        <img src="${___HTML_LOADER_IMPORT_0___}" class="logo-img" alt="Logo">
      </div>
    </div>
    <div class="nav-actions-container">
      <!-- not used yet
      <div class="action-icon">
        <img src="./img/user-icon.svg" class="nav-icon" alt="NavIcon">
      </div>
      -->
      <div class="action-icon" id="logout-button">
        <img src="${___HTML_LOADER_IMPORT_1___}" class="nav-icon" alt="NavIcon">
      </div>
      <!-- not used yet
      <div class="action-icon">
        ...
      </div>
      -->
    </div>
`;
// Exports
export default code;